import {useTranslation} from "next-i18next";
import Checkbox from "./Checkbox";

type CheckListItemBase = {
	id: string | number;
	checked?: boolean;
	price?: number;
	tertiaryLabel?: string;
	defaultChecked?: boolean;
	count?: number;
};

interface ChecklistItemWithFixedLabels extends CheckListItemBase {
	primaryLabel?: string;
	secondaryLabel?: string;
}

interface ChecklistItemWithCustomLabel extends CheckListItemBase {
	customLabel?: JSX.Element;
}

export interface ChecklistItem
	extends CheckListItemBase,
		ChecklistItemWithFixedLabels,
		ChecklistItemWithCustomLabel {
}

// export type ChecklistItem =
//   | ChecklistItemWithFixedLabels
//   | ChecklistItemWithCustomLabel;

interface ChecklistPropsInterface {
	title?: string;
	items: Array<ChecklistItem>;
	mobileVersion?: boolean;
	onChange: (item: string | number, checked: boolean) => void;
	onCountChange?: (itemId: string | number, count: number) => void;
	maxPersonCount?: number;
	extraSpace?: boolean
}

export default function Checklist(props: ChecklistPropsInterface) {
	const {t} = useTranslation();
	return (
		<div className="flex flex-col">
			{props.title && <span className="input-caption">{t(props.title)}</span>}
			<div className={`${props.mobileVersion && "divide-y"}`}>
				{props.items.map((item, idx) => {
					return (
						<Checkbox
							extraSpace={props.extraSpace}
							key={idx}
							mobileVersion={props.mobileVersion}
							item={item}
							onChange={(checked, id) => {
								let ident = id ?? item.primaryLabel ?? idx;
								props.onChange(ident, checked);
							}}
							onCountChange={props.onCountChange}
							maxPersonCount={props.maxPersonCount}
						/>
					);
				})}
			</div>
		</div>
	);
}
